import {
    calculateArea,
    calculateCenterOfPolygon,
    calculatePerimeter,
    calculateZoomLevel,
    filterPolygonPointsByDistance,
} from '../../../../../../core/utils/map.utils';
import { toast } from 'react-toastify';
import { sendDataToParent } from '../../../../base/functions/sendDataToParent';
import { setIsDrawingPolygonState } from '../../../../../../app/redux/slices/isDrawingPolygonSlice';

export const polygonOnCreatedAction = (e, dispatch, singlePolygonCoords, map) => {
    //     const { _leaflet_id } = layer;
    //     setMapLayersData((layers) => [...layers, { id: _leaflet_id, latlngs: layer.getLatLngs()[0] }]);
    const { layer } = e;
    const filteredPolygonCoords = filterPolygonPointsByDistance(layer._latlngs[0]);

    layer._latlngs[0] = filteredPolygonCoords;
    layer.redraw();
    layer.addTo(map);

    // const drawnPolygonCoords = layer.getLatLngs()[0];
    const drawnPolygonArea = filteredPolygonCoords && calculateArea(filteredPolygonCoords);
    const drawnPolygonCenter = filteredPolygonCoords && calculateCenterOfPolygon(filteredPolygonCoords);
    const drawnPolygonPerimeter = filteredPolygonCoords && calculatePerimeter(filteredPolygonCoords);
    const drawnPolygonZoomLevel = filteredPolygonCoords && calculateZoomLevel(filteredPolygonCoords);

    sendDataToParent({
        type: 'polygon-drawn',
        polygonId: layer._leaflet_id,
        drawnPolygonCoords: filteredPolygonCoords,
        drawnPolygonPerimeter,
        drawnPolygonArea,
        drawnPolygonCenter,
        drawnPolygonZoomLevel,
    });
};
